import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Images, LogOut, MessageSquareQuote } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BookingsManager } from "@/components/admin/BookingsManager";
import { GalleryManager } from "@/components/admin/GalleryManager";
import { TestimonialsManager } from "@/components/admin/TestimonialsManager";
import "@/Admin.css";

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("bookings");

  useEffect(() => { if (user === false) navigate("/admin/login", { replace: true }); }, [user, navigate]);

  if (!user) return <div className="admin-loading" data-testid="admin-loading">Loading…</div>;

  return (
    <div className="admin-shell" data-testid="admin-dashboard">
      <aside className="admin-side">
        <a href="/" className="brand-mark light" data-testid="admin-brand-link"><span className="brand-icon">G</span><span>Golden Beauty <b>Touch</b></span></a>
        <nav>
          <button className={tab === "bookings" ? "active" : ""} onClick={() => setTab("bookings")} data-testid="admin-tab-bookings"><CalendarDays size={17} /> Bookings</button>
          <button className={tab === "gallery" ? "active" : ""} onClick={() => setTab("gallery")} data-testid="admin-tab-gallery"><Images size={17} /> Gallery</button>
          <button className={tab === "reviews" ? "active" : ""} onClick={() => setTab("reviews")} data-testid="admin-tab-reviews"><MessageSquareQuote size={17} /> Reviews</button>
        </nav>
        <div className="admin-user">
          <div className="profile-avatar">MS</div>
          <div><strong data-testid="admin-user-name">{user.name}</strong><span>{user.email}</span></div>
          <button onClick={logout} aria-label="Log out" data-testid="admin-logout-button"><LogOut size={16} /></button>
        </div>
      </aside>
      <main className="admin-main">{tab === "bookings" ? <BookingsManager /> : tab === "gallery" ? <GalleryManager /> : <TestimonialsManager />}</main>
    </div>
  );
}
